import { render, staticRenderFns } from "./MessagePanelMain.vue?vue&type=template&id=0a8e2b76&scoped=true"
import script from "./MessagePanelMain.vue?vue&type=script&lang=js"
export * from "./MessagePanelMain.vue?vue&type=script&lang=js"
import style0 from "./MessagePanelMain.vue?vue&type=style&index=0&id=0a8e2b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8e2b76",
  null
  
)

export default component.exports